import Button from "./Button";

function Tabs({ tabs, active, setActiveTab, fullButtons = false, wFull = true, tabsDivId=null}) {
  return (
    <div className={`${wFull ? 'w-full' : ''} overflow-x-auto overflow-y-hidden`}>
      <div className="sm:hidden flex flex-row gap-4 items-center">
        {active || active === 0 ? (
          <select
            id="tabs"
            name="tabs"
            className="block w-full pl-3 pr-10 py-2 pb-2 text-base border-gray-300 focus:outline-none focus:ring-am-500 focus:border-am-500 sm:text-sm"
            value={active}
            onChange={(e) => {
              if (e.target.disabled) return;

              setActiveTab(parseInt(e.target.value));
              if (tabs[e.target.value]?.onClick) {
                tabs[e.target.value]?.onClick();
              }
            }}
          >
            {tabs.map(({ name, disabled }, index) => (
              <option key={`${name}-${index}`} value={index} disabled={disabled === true}>
                {name}
              </option>
            ))}
          </select>
        ) : null}
      </div>

      <div
        className= {`w-full -mb-px overflow-x-auto pb-4 hidden sm:flex items-center gap-x-0`}
        aria-label="Tabs"
        {...(tabsDivId ? {id: tabsDivId} : {})}
      >
        {tabs.map(({ name, onClick, disabled, Icon }, index) => (
          <div key={`${name}-${index}`} className={fullButtons ? "w-full" : ""}>
            <Button
              disabled={disabled === true}
              className="whitespace-nowrap"
              full={fullButtons}
              styleType={"none"}
              textCls={
                "text-base capitalize text-center hover:text-am-700 focus:text-am-700 " +
                (active === index ? "text-am-700" : "text-gray-400")
              }
              paddingCls="pt-1 pb-3 px-4"
              fontCls={
                active === index
                  ? "font-semibold"
                  : "font-normal hover:font-semibolds focus:font-semibold"
              }
              borderCls={
                (active === index
                  ? "border-b-2 border-am-700"
                  : "border-b-2 border-am-400 hover:border-am-700 focus:border-am-700") +
                (disabled === true ? " border-gray-400" : "")
              }
              onClick={() => {
                if (disabled) return;

                setActiveTab(index);
                if (onClick) {
                  onClick();
                }
              }}
            >
              <div className="flex items-center gap-1.5 h-7">
                {!!Icon && <Icon className="w-5 mr-1.5 mt-1" />}
                {name}
              </div>
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Tabs;
